import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QuizStatus } from '@edtech-ui/constants/quiz-status.enum';

@Component({
  selector: 'app-unpublished-quiz-dialog-box',
  standalone: true,
  imports: [],
  templateUrl: './unpublished-quiz-dialog-box.component.html',
  styleUrl: './unpublished-quiz-dialog-box.component.scss'
})
export class UnpublishedQuizDialogBoxComponent {
  constructor(public dialogRef: MatDialogRef<UnpublishedQuizDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { status: QuizStatus, courseId: string }
  ) { }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onRemove(): void {
    this.dialogRef.close(true);
  }
}
